export default __webpack_public_path__ + "static/media/BUSH PRESSING MACHINE.0b140801.png";